import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_chair_workouts_large_checkout~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_chair_workouts_large_checkout'),
			},
		},
	},
]

export default config
